import {Component, DestroyRef, Input, OnChanges, OnInit} from '@angular/core';
import {
  LicenseApplicationModel,
  LicenseCenterModel,
  LicenseModel,
  LicenseNewModel, LicenseUpdateModel
} from "../../../models/license.model";
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {CompanyModel, UpdateCompanyModel} from "../../../models/company.model";
import {LicenseService} from "../../../services/licenses-service/license.service";
import {tap} from "rxjs/operators";
import {Subscription} from "rxjs";
import moment from 'moment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-licenses-license-info-card',
    templateUrl: './licenses-license-info-card.component.html',
    styleUrls: ['./licenses-license-info-card.component.scss'],
    standalone: false
})
export class LicensesLicenseInfoCardComponent implements OnInit, OnChanges {

  @Input() license: LicenseModel;
  @Input() centers: LicenseCenterModel[];
  @Input() applications: LicenseApplicationModel[];

  licenseEditFormErrorMessage: string;
  editLicenseForm = new UntypedFormGroup({
    active: new UntypedFormControl(true),
    licenseInternalId: new UntypedFormControl(null, Validators.required),
    licenseDescription: new UntypedFormControl(null, Validators.required),
    licenseDocument: new UntypedFormControl(null),
    licenseEmail: new UntypedFormControl(null),
    licenseCompanyInternalId: new UntypedFormControl(null, Validators.required),
    licenseCompanyName: new UntypedFormControl({value: null, disabled: true}, Validators.required),
    licenseMultiCenter: new UntypedFormControl(true),
    licenseCenter: new UntypedFormControl({value: null, disabled: true}),
    licenseMultiApp: new UntypedFormControl(true),
    licenseApplication: new UntypedFormControl({value: null, disabled: true}),
    licenseStartDateMillis: new UntypedFormControl(null, Validators.required),
    licenseEndDateMillis: new UntypedFormControl(null, Validators.required),
    licenseQuantity: new UntypedFormControl(null, Validators.required)
  });

  updateLicenseSubscription: Subscription;

  constructor(
    private licenseService: LicenseService,
    private destroyRef: DestroyRef
  ) { }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.license) {
      this.resetEditLicenseForm(this.license);
    }
  }

  private resetEditLicenseForm(data: LicenseModel) {
    const licenseData: any = data;
    let selectedCenter = this.centers.find(c => c.internalId === data.centerInternalId);
    if( selectedCenter ) {
      this.editLicenseForm.get('licenseCenter').enable();
    }
    let selectedApplication = this.applications.find(a => a.internalId === data.applicationInternalId);
    if( selectedApplication ) {
      this.editLicenseForm.get('licenseApplication').enable();
    }
    this.editLicenseForm.patchValue({
      active: data.active,
      licenseInternalId: data.internalId,
      licenseDescription: data.description,
      licenseDocument: licenseData.document ?? licenseData.documentNumber ?? '',
      licenseEmail: licenseData.email ?? licenseData.licenseEmail ?? '',
      licenseCompanyInternalId: data.companyInternalId,
      licenseCompanyName: data.companyName,
      licenseMultiCenter: data.multiCenter,
      licenseCenter: selectedCenter,
      licenseMultiApp: data.multiApp,
      licenseApplication: selectedApplication,
      licenseStartDateMillis: moment(data.startDateMillis),
      licenseEndDateMillis: moment(data.endDateMillis),
      licenseQuantity: data.quantity
    });
  }

  public toggleMultiCenter() {
    if(this.editLicenseForm.get('licenseMultiCenter').value) {
      this.editLicenseForm.get('licenseCenter').disable();
    } else {
      this.editLicenseForm.get('licenseCenter').enable();
    }
  }

  public toggleMultiApp() {
    if(this.editLicenseForm.get('licenseMultiApp').value) {
      this.editLicenseForm.get('licenseApplication').disable();
    } else {
      this.editLicenseForm.get('licenseApplication').enable();
    }
  }

  public clearField(fieldName: string) {
    this.editLicenseForm.patchValue({
      [fieldName]: null
    });
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.internalId === op2.internalId;
    }
  }

  public updateLicense() {
    let centerInternalId = null
    const multiCenter = this.editLicenseForm.get('licenseMultiCenter').value
    if(!multiCenter) {
      centerInternalId = this.editLicenseForm.get('licenseCenter').value.internalId
    }
    let applicationInternalId = null
    const multiApp = this.editLicenseForm.get('licenseMultiApp').value
    if(!multiApp) {
      applicationInternalId = this.editLicenseForm.get('licenseApplication').value.internalId
    }
    const license: LicenseUpdateModel = {
      internalId: this.editLicenseForm.get('licenseInternalId').value,
      companyInternalId: this.editLicenseForm.get('licenseCompanyInternalId').value,
      applicationInternalId,
      centerInternalId,
      description: this.editLicenseForm.get('licenseDescription').value,
      document: this.editLicenseForm.get('licenseDocument').value,
      email: this.editLicenseForm.get('licenseEmail').value,
      quantity: this.editLicenseForm.get('licenseQuantity').value,
      startDateMillis: this.editLicenseForm.get('licenseStartDateMillis').value.valueOf(),
      endDateMillis: this.editLicenseForm.get('licenseEndDateMillis').value.valueOf(),
      multiCenter,
      multiApp,
      active: this.editLicenseForm.get('active').value
    };
    this.updateLicenseSubscription = this.licenseService.updateLicense(license).pipe(
      takeUntilDestroyed(this.destroyRef),
      tap(res => {
        this.licenseEditFormErrorMessage = "Licencia actualizada correctamente"
        this.licenseService.refreshLicense()
      })
    ).subscribe();
  }

  public hasError(field) {
    const formControl = this.editLicenseForm.get(field);
    if (formControl.touched && formControl.invalid) {
      if (formControl.errors.required) {
        return '* Campo obligatorio';
      }
      return '* Campo ' + field + ' inválido';
    }
    return false;
  }

}
